import { NgModule } from '@angular/core';

import { MruConfigService } from '../../shared/mru/mru-config.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { SharePointConfigService } from '../../sharepoint/sharepoint-config.service';
import { DISK_PRELOAD_REQUEST_MAP } from './disk-preload-request-map.injection-token';
import { DISK_PRELOAD_STORAGE_KEY } from './disk-preload-storage-key.injection-token';
import { diskPreloadUrlPatternsFactory } from './disk-preload-url-patterns.factory';
import { DISK_PRELOAD_URL_PATTERNS } from './disk-preload-url-patterns.injection-token';
import { DISK_PRELOAD_USER_ID_STORAGE_KEY } from './disk-preload-user-id-storage-key.injection-token';

@NgModule({
    providers: [
        { provide: DISK_PRELOAD_REQUEST_MAP, useValue: window.diskPreloadRequestMap },
        { provide: DISK_PRELOAD_URL_PATTERNS, useFactory: diskPreloadUrlPatternsFactory, deps: [ ContextService, MruConfigService, SharePointConfigService, CapabilitiesService ] },
        { provide: DISK_PRELOAD_STORAGE_KEY, useValue: window.diskPreloadUrlStorageKey },
        { provide: DISK_PRELOAD_USER_ID_STORAGE_KEY, useValue: window.diskPreloadUserIdStorageKey }
    ]
})
export class DiskPreloadModule { }
